export default __webpack_public_path__ + "static/media/WM0350.34I-41332_-24651_0.b5539cdb.jpg";